import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import forecastGameService from '@/modules/calendar/services/forecast-game-service';
import { PendingForecast } from '@/modules/calendar/model/forecast-game/forecast-game-state';
import { EmptyStateIndicator, Loading } from '@/shared/components/export';
import styles from '@/modules/calendar/components/forecast-game/forecast-frenzy.module.scss';

export default function ForecastFrenzyPending() {
  const [pending, setPending] = useState<PendingForecast[]>();

  useEffect(() => {
    forecastGameService.getState().then(state => setPending(state.pending));
  }, []);

  return (
    <div>
      {pending === undefined && <Loading />}

      {pending?.length === 0 && (
        <EmptyStateIndicator text={'You have no forecasts waiting on a result.'} />
      )}

      {pending && pending.length > 0 && (
        <div className={'d-flex flex-column gap-2'}>
          {pending.map(item => (
            <div
              key={`${item.dataSeriesId}-${item.date}`}
              className={`${styles.pendingRow} text-content d-flex justify-content-between align-items-center`}
            >
              <div>
                <div className={'fw-semibold'}>{item.seriesDisplay}</div>
                <div className={`${styles.pendingDate} text-small`}>
                  {dayjs(item.date).format('DD MMM')}
                </div>
              </div>
              <div className={'text-end'}>
                <span className={`${styles.valuePill} ${styles.valuePillYou}`}>
                  You: {item.userValue}
                </span>
                <span className={`${styles.valuePill} ${styles.valuePillMni}`}>
                  MNI: {item.mniValue ?? '—'}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
